import Vue from 'vue';

const DefaultValues = {
    defaultOrderDialog: {
        isOpen: false,
        sellers: []
    },
    defaultOrderSellerData() {
        return {
            sellerID: null,
            policies: [],
            activePolicies:{
                amount:[],
                credit:[],
                dates:[],
                prepayment:[]
            },
            date: null,
            products: [],
            paymentWay: null,
            creditPolicy: null,
            discounts:[],
            totalDiscount: null,
            totalDiscountAmount: null,
            priceSummary: null,
            priceWithDiscount: null
        }
    },
    defaultOrderProduct() {
        return {
            data: [
                {

                }
            ],
            seller: {

            },
            policies: {

            }
        }
    },
    defaultStoreOrder() {
        return {
            products: [],
            buyer: {},
            dialog: {
                isOpen: false,
                sellers: []
            },
            inProcess: [],
            responseData: null,
            responseSuccessData: [],
        }
    },
    defaultCalculatorValue() {
        return {

        }
    }
};

const store = {
    state: {
        account: {
            beforeLoginPath: '',
            isLogged: false,
            isAuthPending: true,
            profileData:{},
            showLoginDialog: false,
            showRegistrationDialog: false,
            isAuthChecked: null,
        },
        app: {
            name: 'Agrolink',
        },
        appCurrency: 'uah',
        baseInfo: {
            categories: [],
            banners: [],
            paymentWays: [],
            creditGuaranties:[],
            partners:[],
            sortProducts:[],
            content: [],
        },
        basket: {
            items:[]
        },
        compares: {
            items: [],
            isUpdating: false
        },
        breadcrumbs:{
            current:[],
        },
        calculator: [
            /*
            {
                culture: 1,
                hectares: 1000,
                treatments: [
                    [{
                        filters: {
                            category: [35],
                            purposeDrug: [1,2,3],
                            harmfulObject: [18417]
                        },
                        budget: 1000
                    },
                    {
                        filters: {
                            category: [36],
                            purposeDrug: [1,2,3],
                            harmfulObject: [18417]
                        },
                        budget: 1000
                    }],
                    [{
                        filters: {
                            category: [35],
                            purposeDrug: [1,2,3],
                            harmfulObject: [18417]
                        },
                        budget: 1000
                    },
                    {
                        filters: {
                            category: [36],
                            purposeDrug: [1,2,3],
                            harmfulObject: [18417]
                        },
                        budget: 1000
                    }],
                ]
            },
            {
                culture: 2,
                hectares: 3000,
                treatments: [
                    [{
                        filters: {
                            category: [35],
                            purposeDrug: [1,2,3],
                            harmfulObject: [18417]
                        },
                        budget: 1000
                    },
                    {
                        filters: {
                            category: [36],
                            purposeDrug: [1,2,3],
                            harmfulObject: [18417]
                        },
                        budget: 1000
                    }],

                ]
            },*/
        ],
        categories: [],
        chips: {
            attribute: {},
            category: {},
            region: {}
        },
        currency: [
            {id: 1, name: 'uah', cyrName: 'грн', symbol: '₴'},
            {id: 2, name: 'usd', cyrName: 'долл', symbol: '$'},
            {id: 3, name: 'eur', cyrName: 'евр', symbol: '€'}
        ],
        existence: [
            { id: 0, name: 'notAvailable'},
            { id: 1, name: 'inStock'},
            { id: 2, name: 'lowLevel'},
        ],
        favorites: {
            items:[]
        },
        filters: {
            general: {
                actionSubstance: {
                    systemName: 'actionSubstance',
                    type: 'autocompleteMultiple'
                },
                actionType: {
                    systemName: 'actionType',
                    type: 'autocompleteMultiple'
                },
                archive: {
                    systemName: 'is_archive',
                    type: 'switch'
                },
                article: {
                    systemName: 'article',
                    type: 'autocomplete'
                },
                awesomeEnum: {
                    systemName: 'awesomeEnum',
                    type: 'autocomplete'
                },
                bioDrug: {
                    systemName: 'bioDrug',
                    type: 'autocompleteMultiple'
                },
                buyer: {
                    systemName: 'buyer',
                    type: 'autocomplete'
                },
                category: {
                    systemName: 'category',
                    type: 'autocomplete'
                },
                chemicalClass: {
                    systemName: 'chemicalClass',
                    type: 'autocompleteMultiple'
                },
                chemicalComposition: {
                    systemName: 'chemicalComposition',
                    type: 'autocompleteMultiple'
                },
                composition: {
                    systemName: 'composition',
                    type: 'autocompleteMultiple'
                },
                culture: {
                    systemName: 'culture',
                    type: 'autocompleteMultiple'
                },
                company: {
                    systemName: 'company',
                    type: 'autocomplete'
                },
                consideration: {
                    systemName: 'consideration',
                    type: 'switch'
                },
                delivery: {
                    systemName: 'delivery',
                    type: 'switch'
                },
                diseaseTolerance: {
                    systemName: 'diseaseTolerance',
                    type: 'autocompleteMultiple'
                },
                doubleEar: {
                    systemName: 'doubleEar',
                    type: 'autocompleteMultiple'
                },
                droughtProductivity: {
                    systemName: 'droughtProductivity',
                    type: 'autocompleteMultiple'
                },
                droughtTolerance: {
                    systemName: 'droughtTolerance',
                    type: 'autocompleteMultiple'
                },
                existence: {
                    systemName: 'existence',
                    type: 'autocomplete'
                },
                exposureType: {
                    systemName: 'exposureType',
                    type: 'autocompleteMultiple'
                },
                fao: {
                    systemName: 'fao',
                    type: 'autocompleteMultiple'
                },
                gmo: {
                    systemName: 'gmo',
                    type: 'autocomplete'
                },
                growTechnology: {
                    systemName: 'growTechnology',
                    type: 'autocompleteMultiple'
                },
                harmfulObject: {
                    systemName: 'harmfulObject',
                    type: 'autocompleteMultiple'
                },
                herbicideType: {
                    systemName: 'herbicideType',
                    type: 'autocompleteMultiple'
                },
                highOleic: {
                    systemName: 'highOleic',
                    type: 'autocomplete'
                },
                inProcess: {
                    systemName: 'in_process',
                    type: 'switch'
                },
                insecticideType: {
                    systemName: 'insecticideType',
                    type: 'autocompleteMultiple'
                },
                lodgingResistance: {
                    systemName: 'lodgingResistance',
                    type: 'autocompleteMultiple'
                },
                manufacturer: {
                    systemName: 'manufacturer',
                    type: 'autocompleteMultiple'
                },
                maxPrice: {
                    systemName: 'maxPrice',
                    type: 'range'
                },
                minPrice: {
                    systemName: 'minPrice',
                    type: 'range'
                },
                moistureLoss: {
                    systemName: 'moistureLoss',
                    type: 'autocompleteMultiple'
                },
                notill: {
                    systemName: 'notill',
                    type: 'autocompleteMultiple'
                },
                often: {
                    systemName: 'is_often',
                    type: 'switch'
                },
                oiliness: {
                    systemName: 'oiliness',
                    type: 'autocompleteMultiple'
                },
                pack: {
                    systemName: 'pack',
                    type: 'autocompleteMultiple'
                },
                pesticideCharacterAction: {
                    systemName: 'pesticideCharacterAction',
                    type: 'autocompleteMultiple'
                },
                pesticideEffect: {
                    systemName: 'pesticideEffect',
                    type: 'autocomplete'
                },
                pesticideType: {
                    systemName: 'pesticideType',
                    type: 'autocompleteMultiple'
                },
                plantDisease: {
                    systemName: 'plantDisease',
                    type: 'autocompleteMultiple'
                },
                prepareForm: {
                    systemName: 'prepareForm',
                    type: 'autocompleteMultiple'
                },
                product: {
                    systemName: 'product',
                    type: 'autocomplete'
                },
                productivity: {
                    systemName: 'productivity',
                    type: 'autocompleteMultiple'
                },
                productDiscount: {
                    systemName: 'discount',
                    type: 'switch'
                },
                productSystemName: {
                    systemName: 'productSystemName',
                    type: 'autocomplete'
                },
                purposeDrug: {
                    systemName: 'purposeDrug',
                    type: 'autocompleteMultiple'
                },
                region: {
                    systemName: 'region',
                    type: 'autocompleteMultiple'
                },
                recommendedZone: {
                    systemName: 'recommendedZone',
                    type: 'autocompleteMultiple'
                },
                ripenessGroup: {
                    systemName: 'ripenessGroup',
                    type: 'autocompleteMultiple'
                },
                rm: {
                    systemName: 'rm',
                    type: 'autocompleteMultiple'
                },
                seasonality: {
                    systemName: 'seasonality',
                    type: 'autocompleteMultiple'
                },
                seedType: {
                    systemName: 'seedType',
                    type: 'autocompleteMultiple'
                },
                seedWeight: {
                    systemName: 'seedWeight',
                    type: 'autocompleteMultiple'
                },
                selection: {
                    systemName: 'selection',
                    type: 'autocompleteMultiple'
                },
                soilComplexType: {
                    systemName: 'soilComplexType',
                    type: 'autocompleteMultiple'
                },
                soilMicroType: {
                    systemName: 'soilMicroType',
                    type: 'autocompleteMultiple'
                },
                soilEffect: {
                    systemName: 'soilEffect',
                    type: 'autocomplete'
                },
                soilForm: {
                    systemName: 'soilForm',
                    type: 'autocomplete'
                },
                soilType: {
                    systemName: 'soilType',
                    type: 'autocompleteMultiple'
                },
                spikeType: {
                    systemName: 'spikeType',
                    type: 'autocompleteMultiple'
                },
                stressEffect: {
                    systemName: 'stressEffect',
                    type: 'autocomplete'
                },
                vegetationPeriod: {
                    systemName: 'vegetationPeriod',
                    type: 'autocompleteMultiple'
                },
                vegetationTerm: {
                    systemName: 'vegetationTerm',
                    type: 'autocompleteMultiple'
                },
                volchok: {
                    systemName: 'volchok',
                    type: 'autocompleteMultiple'
                },
                wholesale: {
                    systemName: 'wholesale',
                    type: 'switch'
                },
                winterTolerance: {
                    systemName: 'winterTolerance',
                    type: 'autocompleteMultiple'
                },
                weeds: {
                    systemName: 'weeds',
                    type: 'autocompleteMultiple'
                },
            },
            attribute: {},
            category: {},
            region: {}
        },
        geo: {
            regions: []
        },
        language: {
            appLanguage: 'ua',
            appLanguages: ['ua', 'ru'],
            languagePrefix: '',
            prefixes: {
                'ua': '/',
                'ru': '/ru/'
            }
        },
        liqpayCommission: 0.0275,
        noLoginBasket: [],
        order: {
            products: [
                //... defaultOrderProduct
            ],
            buyer:{
                // name: null,
                // lastName: null,
                // email: null
            },
            dialog: {
                isOpen: false,
                sellers:[]
            },
            inProcess:[
                // ...defaultOrderSellerData
            ],
            responseData: null
            /*{
                success: [
                    {
                        seller: {id: 1, firstName: 'Uasya', lastName: 'Pupkin', companyName: 'Mega Inc.'},
                        products: [
                            {
                                dateCreated: "12/12/2012",
                                dateDelivery: "Как можно скорее",
                                discount: 14,
                                id: 115,
                                name: "Калийные - товар № 10",
                                orderNumber: "215-1-115",
                                price: 2880,
                                priceDiscounted: 2526.32,
                                quantity: "54 кг",
                                address: '111 222 333 jdkdd 222 kdddd'
                            },
                            {
                                dateCreated: "12/12/2012",
                                dateDelivery: "Как можно скорее",
                                discount: null,
                                id: 117,
                                name: "Калийные - товар № 10",
                                orderNumber: "215-1-115",
                                price: 2880,
                                priceDiscounted: null,
                                quantity: "54 кг",
                                address: '111 222 333 jdkdd 222 kdddd'
                            },
                        ]
                    },
                ],
                error: [],
            }*/
        },
    },
    getters: {
        appCurrency(state) {
            return state.appCurrency;
        },
        basketItems(state) {
            return state.basket.items;
        },
        calculatorFullData(state) {
            return state.calculator;
        },
        categories(state) {
            return state.baseInfo.categories;
        },
        currencies(state) {
            return state.currency;
        },
        existence(state) {
            return state.existence;
        },
        isLogged(state) {
            return state.account.isLogged
        },
        language(state) {
            return state.language;
        },
        liqpayCommission(state) {
            return state.liqpayCommission;
        },
        noLoginBasket(state) {
            return state.noLoginBasket;
        },
        profileData(state) {
            return state.account.profileData;
        },
        showRegistrationDialog(state) {
            return state.account.showRegistrationDialog;
        },
        account(state) {
            return state.account;
        },
        isComparesUpdating(state) {
            return state.compares.isUpdating
        }
    },
    mutations: {
        setAuthChecked(state, data) {
            this.state.account.isAuthChecked = data;
        },
        deleteFilter(state, data) {
            if(state.filters[data.key] && state.filters[data.key][data.name] !== undefined) {
                delete state.filters[data.key][data.name];
            }
        },
        deleteBasketItems(state,ids) {
            state.basket.items = state.basket.items.filter(item => {
                return ids.indexOf(item.productId) < 0;
            });
        },
        loginDialogHide(state) {
            state.account.showLoginDialog = false;
        },
        loginDialogShow(state) {
            state.account.showLoginDialog = true;
        },
        sellerRegDialogShow(state) {
            state.account.showRegistrationDialog = true;
        },
        sellerRegDialogHide(state) {
            state.account.showRegistrationDialog = false;
        },

        //Calculator
        calculatorSetDefaultItem(state) {
            state.calculator.push({});
        },
        calculatorSetFullData(state, data) {
            state.calculator = data;
        },
        calculatorSetBudget(state, data) {
            Vue.set(state.calculator[data.calculationIdx]
                .treatments[data.treatmentIdx][data.drugIdx], 'budget', data.budget)
        },
        calculatorSetFilter(state, data) {
            if (data.filter.values.length > 0) {
                Vue.set(state.calculator[data.calculationIdx]
                    .treatments[data.treatmentIdx][data.drugIdx].filters, data.filter.name, data.filter.values)
            } else {
                Vue.delete(state.calculator[data.calculationIdx]
                    .treatments[data.treatmentIdx][data.drugIdx].filters, data.filter.name);
            }
        },
        calculatorSetCategoryIDs(state, data) {
            data.categoryIDs.forEach((item, idx) => {
                if(!state.calculator[data.calculationIdx][idx]) {
                    Vue.set(state.calculator[data.calculationIdx].
                        treatments[data.treatmentIdx], idx, {
                                filters: {
                                    category: [item],
                                },
                                budget: null
                            });
                } else {
                    Vue.set(state.calculator[data.calculationIdx].
                        treatments[data.treatmentIdx][idx].filters, 'category', [item]);
                }
            })
        },
        calculatorSetCultureId(state, data) {
            Vue.set(state.calculator[data.idx], 'cultureId', data.cultureId)
        },
        calculatorSetHectaresCnt(state, data) {
            Vue.set(state.calculator[data.idx], 'hectaresCnt', data.hectaresCnt)
        },
        calculatorSetTreatments(state, data) {
            Vue.set(state.calculator[data.idx], 'treatments', data.treatments)
        },
        calculatorDeleteCalculation(state, idx) {
           state.calculator.splice(idx, 1);
        },
        calculatorDeleteCategoryId(state, data) {
            const treatment = state.calculator[data.calculationIdx].treatments[data.treatmentIdx];
            const categoryIdx = treatment.findIndex(item => {
                return item.filters.category[0] === data.categoryId;
            });
            if(categoryIdx >= 0) {
                treatment.splice(categoryIdx, 1);
            }
        },
        calculatorDeleteFilter(state, data) {
            const filter = state.calculator[data.calculationIdx]
                .treatments[data.treatmentIdx][data.drugIdx].filters[data.filterName];

            const filterValueIdx = filter.findIndex(filterValueId => filterValueId === data.filterValueId)

            filter.splice(filterValueIdx, 1)

            if (filter.length === 0) {
                Vue.delete(state.calculator[data.calculationIdx]
                    .treatments[data.treatmentIdx][data.drugIdx].filters, data.filterName)
            }
        },
        calculatorResetAllData(state) {
            state.calculator = [];
        },

        // Categories
        setCategories(state, categories) {
            state.baseInfo.categories = categories;
        },

        // Order
        orderInProcessSetDelivery(state, data) {
            const orderIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);
            if (orderIdx >= 0) {
                const order = state.order.inProcess[orderIdx];
                order.products.forEach((item, idx, arr) => {
                    item.delivery = data.delivery;
                    arr[idx] = item
                });
                order.message = data.message;
                state.order.inProcess[orderIdx] = order;
            }
        },
        orderInProcessUpdate(state, data) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);
            const orderSeller = sellerIdx < 0 ? DefaultValues.defaultOrderSellerData() : state.order.inProcess[sellerIdx];
            orderSeller.policies = data.policies;
            orderSeller.sellerID = sellerIdx < 0 ? data.sellerID : orderSeller.sellerID;

            if(data.date) {
                orderSeller.date = data.date;
            } else if(data.date === 0) {
                orderSeller.date = null;
            }

            if(data.paymentWay) {
                orderSeller.paymentWay = data.paymentWay;
            } else if(data.paymentWay === 0) {
                orderSeller.paymentWay = null;
            }

            if(!orderSeller.products.length) {
                orderSeller.products.push(data.product);
                state.order.inProcess.push(orderSeller);
            } else {
                const productIdx = orderSeller.products.findIndex(item => item.id === data.product.id);

                if(productIdx < 0) {
                    orderSeller.products.push(data.product)
                } else {
                    orderSeller.products[productIdx] = data.product;
                }

                if(sellerIdx < 0) {
                    state.order.inProcess.push(orderSeller);
                } else {
                    state.order.inProcess[sellerIdx] = orderSeller;
                }
            }
        },
        orderInProcessClearProduct(state, productID) {
            state.order.inProcess = state.order.inProcess.filter(item => {
                item.products = item.products.filter(item => item.id !== productID);
                return item.products.length;
            });
        },
        orderReset(state) {
            state.order = DefaultValues.defaultStoreOrder();
        },
        orderResetActivePolicies(state, sellerID) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];

            seller.activePolicies = {
                amount:[],
                credit:[],
                dates:[],
                prepayment:[]
            };

            state.order.inProcess[sellerIdx] = seller;
        },
        orderResetDialog(state) {
            state.order.dialog = DefaultValues.defaultOrderDialog;
        },
        orderResetDiscounts(state, sellerID) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];
            seller.discounts = [];
            seller.totalDiscount = null;
            seller.totalDiscountAmount = null;
            seller.priceWithDiscount = null;


            state.order.inProcess[sellerIdx] = seller;
        },
        orderResetResponse(state) {
            state.order.responseData = null;
        },
        orderSetActivePolicies(state, data) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];

            if(data.policies && data.policies.amount) {
                seller.activePolicies.amount = data.policies.amount;
            }

            if(data.policies && data.policies.credit) {
                seller.activePolicies.credit = data.policies.credit;
            }

            if(data.policies && data.policies.dates) {
                seller.activePolicies.dates = data.policies.dates;
            }

            if(data.policies && data.policies.prepayment) {
                seller.activePolicies.prepayment = data.policies.prepayment;
            }

            state.order.inProcess[sellerIdx] = seller;
        },
        orderSetDiscounts(state, data) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];

            if(data.discounts) {
                seller.discounts = data.discounts;
                seller.totalDiscount = data.discounts.length ? data.discounts.reduce((a,b) => a + b) : null;
            }

            state.order.inProcess[sellerIdx] = seller;
        },
        orderSetProducts(state, products) {
            state.order.products = products;
        },
        orderSetDate(state, data) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];
            seller.date = data.date;
            state.order.inProcess[sellerIdx] = seller;
        },
        orderSetPayment(state, data) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];
            seller.paymentWay = data.paymentWay;
            seller.creditPolicy = data.creditPolicy;
            state.order.inProcess[sellerIdx] = seller;
        },
        orderSetResponseData(state, data) {
            state.order.responseData = data;
        },
        orderSetResponseSuccessData(state, data) {
            state.order.responseSuccessData = data;
        },
        orderSetBuyer(state, buyer) {
            state.order.buyer = buyer;
        },
        orderSetPrice(state, data) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];

            if(data.priceSummary !== undefined) {
                seller.priceSummary = data.priceSummary;
            }

            if(data.priceWithDiscount !== undefined) {
                seller.priceWithDiscount = data.priceWithDiscount;
            }

            if(data.priceWithDiscount && data.priceSummary) {
                seller.totalDiscountAmount = data.priceSummary - data.priceWithDiscount;
            } else {
                seller.totalDiscountAmount = null;
            }

            state.order.inProcess[sellerIdx] = seller;
        },
        orderSetInProcess(state, data) {
            state.order.inProcess = data;
        },
        orderDialogUpdate(state, data) {
            const dialog = state.order.dialog;

            dialog.isOpen = data.isOpen;

            if(data.sellers) dialog.sellers = data.sellers;

            state.order.dialog = dialog;
        },
        orderDateUpdate(state, data) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];

            seller.date = data.value;

            state.order.inProcess[sellerIdx] = seller;
        },
        orderPaymentWayUpdate(state, data) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];

            seller.paymentWay = data.value;

            state.order.inProcess[sellerIdx] = seller;
        },
        orderCreditPolicyUpdate(state, data) {
            const sellerIdx = state.order.inProcess.findIndex(item => item.sellerID === data.sellerID);

            if(sellerIdx < 0) return false;

            const seller = state.order.inProcess[sellerIdx];

            seller.creditPolicy = data.value;

            state.order.inProcess[sellerIdx] = seller;
        },

        resetChips(state, key) {
            Vue.set(state.chips, key, []);
        },
        setAppCurrency(state, currency) {
            state.appCurrency = currency;
        },
        setBasket(state, items) {
            state.basket.items = items.map((item) => {
                item.quantity = item.quantity || null;
                item.calculatedPrice = item.calculatedPrice || null;

                return item;
            });
        },
        setCompares(state, items) {
            state.compares.items = items;
        },
        setComparesIsUpdating(state, data) {
            this.state.compares.isUpdating = data;
        },
        setChips(state, data) {
            Vue.set(state.chips[data.key], data.name, data.value);
        },
        setFavorites(state, items) {
            state.favorites.items = items;
        },
        setFilter(state, data) {
            if(state.filters[data.key] === undefined) return false;

            state.filters[data.key][data.name] = data.value;
        },
        setFilters(state, data) {
            state.filters[data.key] = data.value;
        },
        setNoLoginBasket(state, data) {
            state.noLoginBasket = data;
        },
        setPartners(state, data) {
            state.partners = data;
        },
        setValueGeneral(state, data) {
            Vue.set(state[data.key], data.name, data.value);
        },
        updateAppLanguage(state, language) {
            state.language.appLanguage = language;
        },
        updateBreadcrumbsCurrent(state, current) {
            state.breadcrumbs.current = current;
        },
        updateBreadcrumbsPages(state, pages) {
            state.breadcrumbs.pages = pages;
        },
        updateBeforeLoginPath(state, path) {
            state.account.beforeLoginPath = path;
        },
        updateBasket(state, id) {
            const idx = state.basket.items.indexOf(id);
            if (idx < 0) {
                state.basket.items.push(id);
            } else {
                state.basket.items.splice(idx, 1);
            }
        },
        updateBasketItemQuantity(state, params) {
            const idx = state.basket.items.findIndex((item => item.productId === params.productId));
            if (idx >= 0) {
                state.basket.items.splice(idx, 1, { ...state.basket.items[idx], quantity: params.value });
            }
        },
        updateFiltersCategory(state, data) {
            state.filters.category = data;
        },
        updateFavorites(state, id) {
            const idx = state.favorites.items.indexOf(id);
            if (idx < 0) {
                state.favorites.items.push(id);
            } else {
                state.favorites.items.splice(idx, 1);
            }
        },
        updateIsAuthPending(state, isPending) {
            state.account.isAuthPending = isPending;
        },
        updateLanguagePrefix(state, prefix) {
            state.language.languagePrefix = prefix;
        },
        updateLoggedIn(state, isLogged) {
            state.account.isLogged = isLogged;

            if(!isLogged) state.account.profileData = {};
        },
        updateProfileData(state, profile) {
            state.account.profileData = profile;
        }
    }
};

export default store;
